import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ModalPrompt, buttonTypes } from "@rosetta/react-common-ui";
import { actions as audioQualityModalActions } from "./audio-quality-modals-reducer";
import GenericAudioQualityModal from "./GenericAudioQualityModal";
import { disableSpeech } from "../sreactions";

/**
 * This is the dialog that pops up when the SRE hears silence multiple times in a row.
 *
 * It lets the user choose:
 *  * disable speech,
 *  * re-calibrate speech,
 *  * or continue the learning exercise and ignore the problem.
 *
 */

export var DisableSpeechForNowModal = function (_PureComponent) {
  _inherits(DisableSpeechForNowModal, _PureComponent);

  function DisableSpeechForNowModal() {
    var _temp, _this, _ret;

    _classCallCheck(this, DisableSpeechForNowModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.render = function () {
      var buttons = [{
        labelKey: "sre_audio_quality_disable_speech_for_now_modal_btn_continue_w_speech",
        actionFunc: function actionFunc() {
          return _this.props.hideDisableSpeechForNowModal();
        },
        buttonType: buttonTypes.default
      }, {
        labelKey: "sre_audio_quality_disable_speech_for_now_modal_btn_disable_speech",
        actionFunc: function actionFunc() {
          _this.props.disableSpeech();
          _this.props.disableSpeechForNowModalDisableSpeechAfterAction();
          _this.props.hideDisableSpeechForNowModal();
        },
        buttonType: buttonTypes.primary
      }];

      // remove "turn off speech" button, if user cannot disable speech (e.g. an admin has disallowed this for a user)
      // NOTE: this modal probably shouldn't even show up if the user has
      // the ability to disable speech turned off, since that is the sole purpose
      // of this modal, but removing the button here too as a sanity check
      if (_this.props.userRestrictedFromDisableSpeech) {
        buttons.pop();
      }

      return React.createElement(GenericAudioQualityModal, {
        dataQa: "SreDisableSpeechForNowModal",
        userRestrictedFromDisableSpeech: _this.props.userRestrictedFromDisableSpeech,
        useLoudAudioWaveIcon: true,
        headerTextLionKey: "sre_audio_quality_disable_speech_for_now_modal_title",
        subHeaderTextLionKey: "sre_audio_quality_disable_speech_for_now_modal_sub_title",
        defaultButtonsOverride: buttons,
        tryAgainAction: _this.props.hideDisableSpeechForNowModal,
        hideTipsSection: true
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return DisableSpeechForNowModal;
}(PureComponent);

DisableSpeechForNowModal.defaultProps = {
  // from parent component
  userRestrictedFromDisableSpeech: false
};

DisableSpeechForNowModal.propTypes = {
  // from parent component
  userRestrictedFromDisableSpeech: PropTypes.bool,
  // action creators from redux
  hideDisableSpeechForNowModal: PropTypes.func,
  disableSpeech: PropTypes.func
};

var mapStateToProps = function mapStateToProps(state) {
  return {};
};

var disableSpeechActions = {
  hideDisableSpeechForNowModal: audioQualityModalActions.hideDisableSpeechForNowModal,
  disableSpeech: disableSpeech,
  disableSpeechForNowModalDisableSpeechAfterAction: audioQualityModalActions.disableSpeechForNowModalDisableSpeechAfterAction
};

var DisableSpeechForNowModalContainer = connect(mapStateToProps, disableSpeechActions)(DisableSpeechForNowModal);

export default DisableSpeechForNowModalContainer;